/**
 * Reads the deviceToken JWT claim from an access token.
 * Present only for native device sessions; web sessions return null.
 */
export function getDeviceTokenFromAccessToken(accessToken: string | undefined | null): string | null {
  if (!accessToken) {
    return null;
  }

  try {
    const parts = accessToken.split(".");
    if (parts.length !== 3) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const payload = JSON.parse(atob(padded)) as { deviceToken?: unknown };
    return typeof payload.deviceToken === "string" ? payload.deviceToken : null;
  } catch {
    return null;
  }
}
